/** Преобразует модель с локациями */
export const transformPoints = (points, icons) => {
	let arr;
	let index = 0;
	if (!points) {
		return [];
	}
	arr = points.map(
		({
			id,
			phone,
			refill,
			sale,
			title,
			work_time,
			city: { name: city } = {},
			company: { name: company } = {},
			geo_position
		}) => {
			return {
				id,
				index: index++,
				title,
				city,
				company,
				refill,
				sale,
				image: icons[company],
				placeMark: geo_position
					? [geo_position.latitude, geo_position.longitude]
					: undefined,
				phone:
					phone && phone.length ? phone.map(item => item.number) : undefined,
				workTime:
					work_time && work_time.length
						? work_time.map(item => item.time)
						: undefined
			};
		}
	);
	return arr;
};
